import { render, staticRenderFns } from "./InpatientOrder.vue?vue&type=template&id=85c74f60&"
import script from "./InpatientOrder.vue?vue&type=script&lang=js&"
export * from "./InpatientOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports